export default __webpack_public_path__ + "static/media/backoffice-invoice-sample.2e712570.webp";